// extracted by mini-css-extract-plugin
module.exports = {"lines":"lines-e2ebf8","line":"line-e2ebf8","ellipsisIcon":"ellipsisIcon-e2ebf8","ellipsis":"ellipsis-e2ebf8"};